import { MathUtils } from "three";
import { TypeAssert } from "../../../engine/poly/Assert";
import { CoreObject } from "../../geometry/Object";
import { PerspectiveCameraAttribute } from "../CoreCamera";
import { CameraFrameMode } from "../CoreCameraFrameMode";
import { BaseCoreCameraFrameMode } from "./_BaseCoreCameraFrameMode";
export class CoreCameraPerspectiveFrameMode {
  static updateCameraAspect(camera, aspect) {
    camera.aspect = aspect;
    const frameMode = BaseCoreCameraFrameMode.frameMode(camera);
    const expectedAspectRatio = BaseCoreCameraFrameMode.expectedAspectRatio(camera);
    const fov = CoreObject.attribValue(camera, PerspectiveCameraAttribute.FOV);
    if (fov != null && expectedAspectRatio != null) {
      this._update({
        mode: frameMode,
        camera,
        fov,
        expectedAspectRatio
      });
    }
    camera.updateProjectionMatrix();
  }
  static _update(options) {
    const mode = options.mode;
    switch (mode) {
      case CameraFrameMode.DEFAULT: {
        return this._adjustFOVFromModeDefault(options);
      }
      case CameraFrameMode.COVER: {
        return this._adjustFOVFromModeCover(options);
      }
      case CameraFrameMode.CONTAIN: {
        return this._adjustFOVFromModeContain(options);
      }
    }
    TypeAssert.unreachable(mode);
  }
  static _adjustFOVFromModeDefault(options) {
    options.camera.fov = options.fov;
  }
  static _adjustFOVFromModeCover(options) {
    if (options.camera.aspect > options.expectedAspectRatio) {
      const cameraHeight = Math.tan(MathUtils.degToRad(options.fov / 2));
      const ratio = options.camera.aspect / options.expectedAspectRatio;
      const newCameraHeight = cameraHeight / ratio;
      options.camera.fov = MathUtils.radToDeg(Math.atan(newCameraHeight)) * 2;
    } else {
      options.camera.fov = options.fov;
    }
  }
  static _adjustFOVFromModeContain(options) {
    if (options.camera.aspect > options.expectedAspectRatio) {
      options.camera.fov = options.fov;
    } else {
      const cameraHeight = Math.tan(MathUtils.degToRad(options.fov / 2));
      const ratio = options.camera.aspect / options.expectedAspectRatio;
      const newCameraHeight = cameraHeight / ratio;
      options.camera.fov = MathUtils.radToDeg(Math.atan(newCameraHeight)) * 2;
    }
  }
}
